import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import TemplateViewer from './components/templateviewer/TemplateViewer';
import Information from './components/information/Information';
import Contact from './components/pricing/Contact';
import Message from './components/message/Message';
import BrokerMessage from './components/message/BrokerMessage';
import Signup from './components/signup/Signup';
import Header from './components/header/templateheader';
import Templates from './components/templateviewer/Templates';
import AgentTemplates from './components/templateviewer/AgentTemplates';
import BrokerageTemplates from './components/templateviewer/BrokerageTemplates';
import LandingPages from './components/templateviewer/LandingPages';
import Newsletters from './components/templateviewer/Newsletters';
import PricingPage from './components/pricing/PricingPage';
import Socials from './components/socials/Socials';
import WebsiteSignup from './components/promotional/WebsiteSignup';
import WebsiteWinnerSignup from './components/promotional/WebsiteWinnerSignup';
import './App.css';
import Footer from './components/footer/Footer';
import PrivacyPolicy from './components/policy/PrivacyPolicy';
import TermsCondition from './components/policy/termsCondition';
import AgencyHome from './components/agency/AgencyHome';
import SEOPage from './components/agency/SEOPage';
import BrandingPage from './components/agency/BrandingPage';

const Home = () => {
    return (
        <AgencyHome />
    );
};

// Add this component to handle scroll-to-top on route change
function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
}

function App() {
    const [viewMode, setViewMode] = useState('laptop');

    return (
        <>
            <HelmetProvider>
                <Helmet>
                    <title>AptoWebsites - Modern Real Estate Websites</title>
                    <meta name="description" content="AptoWebsites offers modern, SEO-optimized real estate websites for agents, brokerages, and teams. Mobile-friendly, fast, and conversion-focused." />
                    <meta name="keywords" content="real estate websites, agent websites, brokerage websites, real estate templates, web design, SEO, mobile-friendly, AptoWebsites" />
                    <meta property="og:title" content="AptoWebsites - Modern Real Estate Websites" />
                    <meta property="og:description" content="Get a high-impact, SEO-optimized website for your real estate business. Fast, mobile-ready, and designed to convert." />
                    <meta property="og:type" content="website" />
                    <meta property="og:url" content="https://aptowebsites.com/" />
                    <meta property="og:image" content="https://aptowebsites.com/og-image.jpg" />
                    <link rel="canonical" href="https://aptowebsites.com/" />
                </Helmet>
                <BrowserRouter>
                    <ScrollToTop />
                    <Header setViewMode={setViewMode} />
                    <main id="main-content" className={`app-container ${viewMode}`}>
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/templates" element={<Templates />} />
                            <Route path="/agent-templates" element={<AgentTemplates />} />
                            <Route path="/brokerage-templates" element={<BrokerageTemplates />} />
                            <Route path="/landing-pages" element={<LandingPages />} />
                            <Route path="/newsletters" element={<Newsletters />} />
                            <Route path="/pricing" element={<PricingPage />} />
                            <Route path="/:templateId" element={<TemplateViewer />} />
                            <Route path="/information" element={<Information />} />
                            <Route path="/contact" element={<Contact />} />
                            <Route path="/message" element={<Message />} />
                            <Route path="/brokermessage" element={<BrokerMessage />} />
                            <Route path="/signup" element={<Signup />} />
                            <Route path="/socials" element={<Socials />} />
                            <Route path="/seo" element={<SEOPage />} />
                            <Route path="/branding" element={<BrandingPage />} />
                            <Route path="/signup/website/*" element={<WebsiteSignup />} />
                            <Route path="/winner/website/*" element={<WebsiteWinnerSignup />} />
                            <Route path='/privacy-policy' element={<PrivacyPolicy />} />
                            <Route path='/terms-and-conditions' element={<TermsCondition />} />
                            {/* <Route path="/samples/:sampleName" element={<SampleViewer />} /> */}
                        </Routes>
                    </main>
                    <Footer />
                </BrowserRouter>
            </HelmetProvider>
        </>
    );
}

export default App;
